import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import Menu from "./menu"
import { Navbar, Nav, Form, Button, Container } from "react-bootstrap"
import Icon from "../assets/JMFinnLogo.svg"
import { trackCustomEvent } from 'gatsby-plugin-google-analytics'

const CustomNavbar = ({ pageInfo }) => {

  const [expanded, setExpanded] = useState(false);

  function toggleNav() {

    setExpanded(expanded ? false : "expanded")

    const pageContainer = document.getElementById('___gatsby')
    if(expanded === false && pageContainer.classList.contains("collapsed")) {
      pageContainer.classList.remove("collapsed")
      pageContainer.parentElement.classList.remove('navbar-expanded')
    }

    if(pageContainer.classList.contains("collapsed")) {
      pageContainer.classList.remove("collapsed")
      pageContainer.parentElement.classList.remove('navbar-expanded')

      // Remove injected DOM on collapse
      let secondaryMenuItemsInjected = document.getElementsByClassName('mm-secondary-menu')
      if(secondaryMenuItemsInjected.length > 0) {
        secondaryMenuItemsInjected[0].parentNode.removeChild(secondaryMenuItemsInjected[0]);
      }

    }else {
      pageContainer.classList.add("collapsed")
      pageContainer.parentElement.classList.add('navbar-expanded')

      // Get secondary menu items and inject into mobile menu
      let secondaryMenu =  ''
      let secondaryMenuItems = document.querySelectorAll('.nav--secondary .nav-item')
      let secondaryMenuItemsLength = secondaryMenuItems.length

      for (let i = 0; i < secondaryMenuItemsLength; ++i) {
        secondaryMenu = secondaryMenu + secondaryMenuItems[i].innerHTML
      }

      // Inject into DOM before the button
      var menuButton = document.querySelector('#basic-navbar-nav a.btn-primary.btn-sm')
      if(menuButton !== undefined) {
        var div = document.createElement('div')
            div.innerHTML = secondaryMenu
            div.className = 'mm-secondary-menu'

        menuButton.parentNode.insertBefore(div, menuButton)
      }

    }

    const links = document.querySelectorAll("#site-navbar a:not(.dropdown-toggle)")
    for (const link of links) {
      link.addEventListener('click', function(event) {
        toggleNav()
        const pageContainer = document.getElementById('___gatsby')
        pageContainer.classList.remove("collapsed")
        pageContainer.parentElement.classList.remove('navbar-expanded')
      })
    }
  }

  const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }

  function pageResize() {
    const pageContainer = document.getElementById('___gatsby')
    if (pageContainer.classList.contains("collapsed")) {
      toggleNav()
      const pageContainer = document.getElementById('___gatsby')
      pageContainer.classList.remove("collapsed")
      pageContainer.parentElement.classList.remove('navbar-expanded')
    }

    appHeight();
  }

  function handleOpen() {
    const searchTool = document.getElementById("js-site-search"),
    searchInput = document.getElementById("js-site-search-input")

    searchTool.classList.add("active")
    if(searchInput) searchInput.focus()

    trackCustomEvent({
      category: "Navigation",
      action: "Click",
      label: "Search"
    })
  }

  useEffect(() => {
    window.addEventListener("resize", pageResize)
    window.addEventListener("scroll", appHeight)
    return () => {
      window.removeEventListener("resize", pageResize)
    }
  })

  useEffect(() => {
    appHeight()
  }, [])

  return (
    <>
      <div className="wrapper">
        <Container fluid>
          <Link className="site-brand" to="/" aria-label="JMFinn logo">
            <Icon width="140" />
          </Link>
          <a className="phone-link RT-placeholder rTapNumber433518" href="tel:02076001660" aria-label="JMFinn telephone icon"></a>
          <Form>
            <Button aria-label="Search" variant="search" label="Search" onClick={handleOpen}></Button>
          </Form>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => toggleNav()}
          />
          <Navbar expand="lg" id="site-navbar" expanded={expanded}>
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto" activeKey={pageInfo && pageInfo.pageName}>
                <Menu menuName="main" menuClass="navbar-nav" />
                
                <div className="mmSecondaryMenu">
                  <Menu menuName={`secondary-header-menu`} />
                </div>

                <Button onClick={e => {
                  trackCustomEvent({
                    category: "Navigation",
                    action: "Click",
                    label: "Login"
                  })
                }} variant="primary" size="sm" target="_blank" href="https://valuations.jmfinn.com/clientportal/Public/Login" rel="nofollow">Login</Button>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </Container>
      </div>
    </>
  )
}

export default CustomNavbar
